import React from 'react';

const NoMatch = () => {
    return (
        <>
         <div className="d-flex align-items-center justify-content-center" style={{height:'80vh'}}>
             <h1 className="text-danger text-center">404! Page Not Found  <br/> Please Try Again!!! </h1>
         </div>  
        </>
    );
};

export default NoMatch;